export default {
  label: {
    button: {
      create: 'Criar',
      save: 'Salvar',
    },
    table: {
      homologEnv: 'Homologação',
      prodEnv: 'Produção',
    },
    message: {
      hint: {
        email: 'Escreva um email e aperte "enter".',
      },
      error: {
        emptyField: 'Não pode ser vazio.',
        withoutSpace: 'Não são permitidos espaços',
        mustBeNumber: 'Não são permitidos letras.',
        invalidInfo: 'Máximo de 16 caracteres.',
        addEmail: 'Adicione algum email.',
        addAllEmails: 'Todos emails precisam ser validos.',
        invalidEmail: 'Adicione um email válido',
        invalidId: 'ID inválido.',
      }
    }
  }
};
